import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { stacked } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';

export const FaqContent = styled.section`
  & > h3 {
    ${stacked._1x};
    ${font.md};
    font-weight: bold;
  }

  & > p {
    ${stacked._3x};
    ${font.sm};
    color: ${colors['$hpx-grey-600']};
  }

  & > figure {
    ${stacked._2x};

    & > figcaption {
      ${font.sm};
      color: ${colors['$hpx-grey-600']};
    }
  }

  & > ul {
    ${stacked._3x};

    & > li {
      ${stacked._2x};
      color: ${colors['$hpx-grey-600']};
      ${font.sm};
    }
  }

  & > ol {
    ${stacked._3x};

    & > li {
      ${stacked._2x};
      color: ${colors['$hpx-grey-600']};
      ${font.sm};

      & > a {
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-offset: 5px;
        }
      }
    }
  }
`;
